export default "__VITE_ASSET__DAqa_TPX__"